import React from 'react'
import { SketchElement } from '../../../../../../inspector'
import { ElementInfo } from './ElementInfo'
import * as S from './Overview.styles'

type OverviewProps = {
  sketchElement: SketchElement
}
/**
 * Overview info of the given sketchElement. The overviews shows an icon
 * corresponding to the element type, the name and sometimes the symbol name path
 * or a "copy css" button when relevant.
 */
export const Overview: React.FC<OverviewProps> = ({ sketchElement }) => {
  if (!sketchElement) {
    return null
  }

  return (
    <S.OverlaySection data-testid="inspector-sidebar-overview">
      <S.OverlayAttribute>
        <ElementInfo sketchElement={sketchElement} />
      </S.OverlayAttribute>
    </S.OverlaySection>
  )
}
